import { ComponentProps } from 'react';

import { MediaGallery } from '~modules/media-gallery/view/MediaGallery';

export default function MediaGalleryController(props: Resolve<ComponentProps<typeof MediaGallery>>) {
  return <MediaGallery {...props} />;
}
